// removed by extract-text-webpack-plugin
module.exports = {"label":"label___1-VNk","input":"input___IJO_w","schemas":"schemas___1QOuW","warn":"warn___2iPif"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditorGUI/Text/styles.scss
// module id = 449
// module chunks = 0